import { render } from "./Artboard_DarkWickpick.vue?vue&type=template&id=1f8baa97&scoped=true"
import script from "./Artboard_DarkWickpick.vue?vue&type=script&lang=js"
export * from "./Artboard_DarkWickpick.vue?vue&type=script&lang=js"

import "./Artboard_DarkWickpick.vue?vue&type=style&index=0&id=1f8baa97&scoped=true&lang=css"
import "./Artboard_DarkWickpick.vue?vue&type=style&index=1&id=1f8baa97&lang=css"
script.render = render
script.__scopeId = "data-v-1f8baa97"

export default script